import api from "@/lib/axios";


export const vacancyStatusSettingsService = {
    // get vacancy status settings by vacancy id

    // vacancy/:vacancyId/vacancy-status/:vacancyStatusId/vacancy-status-setting    
    getVacancyStatusSettingsByVacancyId: async (vacancyId, vacancyStatusId) => {
        try {
            if(!vacancyId || !vacancyStatusId) {
                throw new Error("Vacancy ID and vacancy status ID are required");
            }
            const response = await api.get(`/vacancy/${vacancyId}/vacancy-status/${vacancyStatusId}/setting`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to fetch vacancy status settings: " + error.message);
        }
    },

    // create vacancy status settings
    // vacancy id
    // status id

    //vacancy/:vacancyId/vacancy-status/:vacancyStatusId/setting
    createVacancyStatusSettings: async (vacancyId, vacancyStatusId, data) => {
        try {
            const response = await api.post(`/vacancy/${vacancyId}/vacancy-status/${vacancyStatusId}/setting`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response.data.message);
        }
    },
};






